import { render, staticRenderFns } from "./ControlResultBadge.vue?vue&type=template&id=1ab1b96e&"
import script from "./ControlResultBadge.vue?vue&type=script&lang=js&"
export * from "./ControlResultBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports